import React from "react";

import styles from './LoadingSpinner.css';

const LoadingSpinner = () => (
  <div className={styles.loadingSpinner}>
    <div className={styles.spinwrap}>
      <div className={styles.spinner}>
        <div className={styles.cube1}></div>
        <div className={styles.cube2}></div>
      </div>
    </div>
  </div>
);

export default LoadingSpinner;
